/**
 * 客户线索「编辑客户信息 / 客户来源」可编辑性判定（纯函数，便于单测与复用）。
 *
 * 需求来源（2026-10-28，Yvonne Huang 原话）：
 *   「客户来源这里销售填了之后我希望我有权限可以修改，不然他们没填，我也改不了。」
 *
 * 背景：她是分公司销售部经理（branch_sales_manager）。后端 PATCH /crm/leads/{lid}
 * 早已改为 `ensure_perm("/crm/leads::edit", 原名单)`，认账号级菜单授权；但客户详情页的
 * 「编辑信息」按钮与页面内多处编辑开关仍用写死的角色名单，她不在名单里 ——
 * 于是「管理员在账号菜单里勾了 CRM，她却连编辑弹窗都打不开」，正是 AGENTS.md 明令禁止的
 * 「配置和代码两套口径」。本函数把判定收成一处，页面与单测共用同一份语义。
 *
 * 三态语义（与项目其它动作点一致，见 AppContext 的 permOf）：
 *   · perm === true      → 服务端判定允许（含管理员单独授予的动作点 / 从父页面 /crm/leads 继承）；
 *   · perm === false     → 服务端判定拒绝（含对该动作点的显式屏蔽 —— 收权立刻生效）；
 *   · perm 为 undefined  → 权限快照未加载或后端旧版本 → 退回改造前的原名单，行为逐字不变。
 * poolView（公海客户只读）优先于权限：这是「先捞取才能编辑」的既有业务规则，
 * 不因为一次授权就被绕过。
 */

/** 改造前「编辑客户信息」按钮的角色名单 —— 仅在权限快照不可用时作兜底，**不是**新的授权依据。 */
export const LEAD_EDIT_FALLBACK_ROLES = ["admin", "ceo", "sales_vp", "sales_manager", "marketing", "eng_manager", "sales"];

export const resolveLeadEditPermission = ({ perm, role, poolView }) => {
  if (poolView) return false;
  if (perm !== undefined && perm !== null) return !!perm;
  return LEAD_EDIT_FALLBACK_ROLES.includes(role);
};
